import { PlayIcon } from '@/components/icons/play-icon';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import * as React from 'react';

type PlayButtonProps = Omit<
  React.ComponentProps<typeof Button>,
  'aria-label' | 'children' | 'className' | 'data-test' | 'size' | 'type' | 'variant'
> & {
  ariaLabel: string;
  className?: string;
  dataTest: string;
  iconClassName?: string;
};

export const PlayButton = React.forwardRef<HTMLButtonElement, PlayButtonProps>(({
  ariaLabel,
  className,
  dataTest,
  iconClassName,
  ...buttonProps
}, ref): React.JSX.Element => {
  return (
    <Button ref={ref}
      {...buttonProps}
      aria-label={ariaLabel}
      className={cn(
        'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full',
        'bg-black/45 hover:bg-black/60 transition-colors border-2 border-white hover:border-white',
        'z-10 flex items-center justify-center cursor-pointer size-[60px] fill-white',
        className
      )}
      data-test={dataTest}
      size="icon"
      type="button"
      variant="ghost"
    >
      <PlayIcon aria-hidden="true"
        className={cn('size-[40%] translate-x-0.5', iconClassName)}
      />
    </Button>
  );
});
